import { literal, number, object } from "superstruct";

export const RewardsPointsRewardSchema = object({
    type: literal("points"),
    points: number(),
});
